<script setup>
  import { useTemplateRef, ref, watch } from 'vue'

  defineProps({
    item: Object
  })

  const body = useTemplateRef('body')
  const open = ref(false)

  const bodyStyle = ref({
    maxHeight: '0px'
  })

  watch(open, () => {
    if (open.value) {
      bodyStyle.value.maxHeight = body.value.scrollHeight + 50 +   'px'
    } else {
      bodyStyle.value.maxHeight = '0px'
    }
  })
</script>

<template>
  <div
    class="app-accordeon-item last:border-b border-border"
  >
    <div
      class="app-accordion-item-header cursor-pointer relative py-7 border-t border-border hover:pl-4 transition-all duration-300 ease-in-out"
      @click="open = !open"
    >
      <h3
        class="max-w-[85%] lg:max-w-[90%] mb-0"
      >
        {{ item.header }}
      </h3>
      <div
        class="app-accordion-item-indicator absolute top-8 ~right-5/10 transition-transform duration-300 ease-in-out"
        :class="open ? 'rotate-180' : ''"
      >
        <AppIcon
          name="Chevron"
        />
      </div>
    </div>
    <div
      ref="body"
      :style="bodyStyle"
      class="app-accordion-item-body overflow-hidden transition-max-height duration-300 ease-in-out"
    >
      <div
        class="app-accordion-body-inner pb-7"
        v-html="item.body[0]"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .app-accordion-item-indicator {
    :deep(svg) {
      @apply h-4 w-4;
    }
  }
</style>
